import React from 'react';
import { AvButton } from '@fabric-ui/components';
import { Box, SxProps } from '@mui/material';
import { Link } from '@tanstack/react-router';

export enum DisclaimerType {
  ACCEPTABLE_USE_POLICY = 'ACCEPTABLE_USE_POLICY',
  PRODUCT_OUTPUT_DISCLAIMER = 'PRODUCT_OUTPUT_DISCLAIMER',
  CONTACT_SUPPORT = 'CONTACT_SUPPORT',
}

const disclaimerConfig = {
  [DisclaimerType.ACCEPTABLE_USE_POLICY]: {
    text: 'Acceptable Use Policy',
    url: 'https://help.zscaler.com/product-usage-terms/acceptable-use-policy',
  },
  [DisclaimerType.PRODUCT_OUTPUT_DISCLAIMER]: {
    text: 'Product Output Disclaimer',
    url: 'https://help.zscaler.com/legal/product-output-disclaimer',
  },
  [DisclaimerType.CONTACT_SUPPORT]: {
    text: 'Contact support',
    url: '',
  },
};

interface CopilotDisclaimerProps {
  variant?: React.ComponentProps<typeof AvButton>['variant'];
  sx?: SxProps;
  type?: DisclaimerType;
  onClick?: () => void;
}

const CopilotDisclaimer = ({ variant = 'link', sx = {}, type = DisclaimerType.ACCEPTABLE_USE_POLICY, onClick }: CopilotDisclaimerProps) => {
  const { text, url } = disclaimerConfig[type];

  return (
    <AvButton
      size="xSmall"
      variant={variant}
      sx={{ p: 0, fontSize: 12, display: 'contents', ...sx }}
      {...(onClick ? { onClick } : { component: Link, to: url, target: '_blank' })}>
      {text}
    </AvButton>
  );
};

export default CopilotDisclaimer;

export const AiInteractionDisclaimer = () => (
  <Box sx={{ width: '100%', px: 3, pb: 2 }}>
    <Box
      sx={{
        fontSize: '12px',
        border: '1px solid var(--color-border-base-primary)',
        p: 1,
        borderRadius: '12px',
        backgroundColor: 'var(--color-surface-base-primary)',
      }}>
      {`You are interacting with AI. Outputs may be inaccurate.
      See the `}
      <CopilotDisclaimer variant="primaryText" /> and{' '}
      <CopilotDisclaimer variant="primaryText" type={DisclaimerType.PRODUCT_OUTPUT_DISCLAIMER} />
    </Box>
  </Box>
);
